const active = state => state.list.filter(item => item.active).map(item => item.id)

const listOrdered = state => state.list.sort((a, b) => (a.description > b.description) ? 1 : -1)

export default {
  active,
  listOrdered,
}
